export default __webpack_public_path__ + "assets/logos/aa29aebc96a4446ea9e8a2549aa0946e.png";